function setEdiparts(state, ediparts) {
	state.ediparts = ediparts;
}

function addNewEdipart(state, edipart) {
	state.ediparts.push(edipart);
}

function removeEdipartFromList(state, edipartId) {
	let index = state.ediparts.findIndex(x => x.id === edipartId);
	state.ediparts.splice(index, 1);
}

function updateEdipartState(state, updateInfo) {
	state.ediparts[updateInfo.index] = updateInfo.edipart;
}
export default { setEdiparts, addNewEdipart, removeEdipartFromList, updateEdipartState };